import React from 'react';
import { Button, Upload, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { PaperClipOutlined, CameraOutlined, LoadingOutlined } from '@ant-design/icons';
import { commonIconButtonStyle } from '../../../../Shared/Styles/iconButton';

const FooterUpload = ({
    isNative,
    accept,
    onFileUpload,
    setFileList,
    uploading,
    uploadingCamera,
    uploadingGallery,
    handleCameraClick,
    handleGalleryClick,
    isMobile,
    mobileButtonStyle,
    buttonStyle, // New prop for custom styling
    ICON_SIZE,
    iconSize
}) => {
    const { t } = useTranslation();

    const tt = (key, fallback) => {
        const value = t(key);
        return value === key ? fallback : value;
    };

    // Use passed buttonStyle or fallback to mobileButtonStyle (for mobile) or commonIconButtonStyle (desktop implicit)
    // Actually, we want to allow buttonStyle to override everything if passed.
    const finalButtonStyle = buttonStyle || (isMobile ? mobileButtonStyle : commonIconButtonStyle);

    const handleBeforeUpload = async (file) => {
        const uploadedFile = await onFileUpload(file);
        if (uploadedFile) {
            setFileList((prev) => [...prev, uploadedFile]);
        }
        return false;
    };

    if (isMobile) {
        return (
            <>
                {isNative ? (
                    <>
                        <Button
                            aria-label={tt('camera', 'Camera')}
                            icon={uploadingCamera ? <LoadingOutlined style={{ fontSize: iconSize }} /> : <CameraOutlined style={{ fontSize: iconSize }} />}
                            type="text"
                            onClick={handleCameraClick}
                            style={{ ...finalButtonStyle, color: '#1DA1F2' }}
                            disabled={uploadingCamera || uploadingGallery}
                        />
                        <Button
                            aria-label={tt('attach', 'Attach')}
                            icon={uploadingGallery ? <LoadingOutlined style={{ fontSize: iconSize }} /> : <PaperClipOutlined style={{ fontSize: iconSize }} />}
                            type="text"
                            onClick={handleGalleryClick}
                            style={{ ...finalButtonStyle, color: '#52c41a' }}
                            disabled={uploadingCamera || uploadingGallery}
                        />
                    </>
                ) : (
                    <Upload
                        accept={accept || undefined}
                        multiple
                        showUploadList={false}
                        beforeUpload={handleBeforeUpload}
                    >
                        <Button
                            aria-label={tt('attach', 'Attach')}
                            icon={uploading ? <LoadingOutlined style={{ fontSize: iconSize }} /> : <PaperClipOutlined style={{ fontSize: iconSize }} />}
                            type="text"
                            style={{ ...finalButtonStyle, color: '#1DA1F2' }}
                            disabled={uploading}
                        />
                    </Upload>
                )}
            </>
        );
    }

    // Desktop View
    return (
        <>
            {isNative ? (
                <>
                    <Tooltip title={tt('camera', 'Camera')}>
                        <Button
                            aria-label={tt('camera', 'Camera')}
                            icon={uploadingCamera ? <LoadingOutlined style={{ fontSize: ICON_SIZE }} /> : <CameraOutlined style={{ fontSize: ICON_SIZE }} />}
                            type="text"
                            onClick={handleCameraClick}
                            style={{ ...finalButtonStyle, color: '#1DA1F2' }}
                            disabled={uploadingCamera || uploadingGallery}
                        />
                    </Tooltip>
                    <Tooltip title={tt('attach', 'Attach')}>
                        <Button
                            aria-label={tt('attach', 'Attach')}
                            icon={uploadingGallery ? <LoadingOutlined style={{ fontSize: ICON_SIZE }} /> : <PaperClipOutlined style={{ fontSize: ICON_SIZE }} />}
                            type="text"
                            onClick={handleGalleryClick}
                            style={{ ...finalButtonStyle, color: '#52c41a' }}
                            disabled={uploadingCamera || uploadingGallery}
                        />
                    </Tooltip>
                </>
            ) : (
                <Upload
                    accept={accept || undefined}
                    multiple
                    showUploadList={false}
                    beforeUpload={handleBeforeUpload}
                >
                    <Tooltip title={tt('attach', 'Attach')}>
                        <Button
                            aria-label={tt('attach', 'Attach')}
                            icon={uploading ? <LoadingOutlined style={{ fontSize: ICON_SIZE }} /> : <PaperClipOutlined style={{ fontSize: ICON_SIZE }} />}
                            type="text"
                            style={{ ...finalButtonStyle, color: '#1DA1F2' }}
                            disabled={uploading}
                        />
                    </Tooltip>
                </Upload>
            )}
        </>
    );
};

export default FooterUpload;
